import React, { useContext } from 'react';
import { CnResult } from '@/components/cn-result';
import { CnCard } from '@/components/cn-card';
import { CardItemsStateCtx } from '../../context/card-items';
import { LoadMore } from '../load-more';
import { Item } from '../item';
/** 卡片列表 */
export const List = () => {
    const { loading, dataSource, primaryKey } = useContext(CardItemsStateCtx);
    if (!loading && !dataSource?.length) {
        return (React.createElement(CnCard, { className: "cn-ui-m-card-items-empty" },
            React.createElement(CnResult, { type: "empty" })));
    }
    return (React.createElement("div", { className: "cn-ui-m-card-items" },
        dataSource?.map((item, i) => (React.createElement(Item, { key: primaryKey && item[primaryKey] ? String(item[primaryKey]) : i, rowIndex: i, data: item }))),
        React.createElement(LoadMore, null)));
};
